/**
 * Utility functions for working with D3 hierarchy data structures
 */

/**
 * Recursively search for a node by ID in the D3 hierarchy
 * Searches both expanded (children) and collapsed (_children) nodes
 * @param node - The root D3 node to start searching from
 * @param id - The ID to search for
 * @returns The matching D3 node or null if not found
 */
export function findD3NodeById(node: any, id: number): any {
    if (!node) return null;
    if (node.data?.id === id) return node;
    
    // Search expanded children
    if (node.children) {
        for (const child of node.children) {
            const found = findD3NodeById(child, id);
            if (found) return found;
        }
    }
    
    // Search collapsed children
    if (node._children) {
        for (const child of node._children) {
            const found = findD3NodeById(child, id);
            if (found) return found;
        }
    }
    
    return null;
}
